<template>
  <ul id="others-section" role="list" class="category-section list-unstyled">
    <h2 class="category-section-title" tabindex="0" aria-modal="true" v-show="tc.categoryList.length > 0">
      {{ otherTitle ? $t('others') : $t('cookies') }}
    </h2>
    <pc-leg-tc-category-block
      v-for="category in tc.categoryList"
      :key="'c' + category.id"
      :category="category"
      :settings="settings"
      @show-related-vendors="$emit('show-related-vendors', $event)"
    ></pc-leg-tc-category-block>
  </ul>
</template>
<script>
import PcLegTcCategoryBlock from '@/components/providers/tc/pc-leg-tc-category-block';

import { i18nMixin } from 'shared/i18n/i18n-mixin';

export default {
  components: {
    PcLegTcCategoryBlock,
  },
  mixins: [i18nMixin],
  props: {
    tc: {
      type: Object,
    },
    settings: {
      type: Object,
    },
    otherTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
